import { ConversationalChatVisibility } from '@klant/conversational-connector/klant-conversational-connector.model';
import { ConversationalChatMapper } from '@klant/conversational-connector/mappers/conversational-chat-mapper/conversational-chat.mapper';
import { ConversationalConnectorAnalyticsService } from '@klant/conversational-connector/services/analytics/analytics.service';

import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';

import { ApContentService } from '@ap/content';
import { FloatingActionButtonModel } from '@ap/floating-action-button';

import { ConversationalChatStore } from '../../../signal-stores/conversational-chat-store/conversational-chat.store';

import content from './conversational-chat-container.content.json';

@Component({
    selector: 'conversational-chat-container',
    templateUrl: './conversational-chat-container.component.html',
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ConversationalChatContainerComponent {
    private readonly conversationalChatStore = inject(ConversationalChatStore);
    private readonly conversationalConnectorAnalyticsService = inject(ConversationalConnectorAnalyticsService);
    private readonly apContentService = inject(ApContentService);

    public readonly isChatOpenedOrMinimized = computed(() => {
        const chatVisibility = this.chatVisibility();
        return chatVisibility === ConversationalChatVisibility.OPEN || chatVisibility === ConversationalChatVisibility.MINIMIZED;
    });
    public readonly isChatOpen = computed(() => this.chatVisibility() === ConversationalChatVisibility.OPEN);
    public readonly unreadMessageCount = this.conversationalChatStore.unreadMessageCount;

    private readonly chatVisibility = this.conversationalChatStore.chatVisibility;

    public constructor() {
        this.apContentService.addContentItems(content);
    }

    public changeChatVisibility(status: FloatingActionButtonModel): void {
        if (this.conversationalChatStore.idleTimerActive()) {
            this.conversationalConnectorAnalyticsService.clickEvent('Minimize', 'Minimaliseren tijdens inactiviteitsmelding');
        } else {
            this.conversationalConnectorAnalyticsService.clickEvent('Conversational', status);
        }

        const conversationVisibility = ConversationalChatMapper.mapFloatingActionButtonModelToConversationalChatVisibility(status);
        this.conversationalChatStore.setChatVisibility(conversationVisibility);
    }
}
